






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ToggleButton extends Vue {
	@Prop({ default: false }) state!: boolean;

	active: boolean = this.state;

	@Watch('state')
	onStateChange() {
	    this.active = this.state;
	}

	Toggle() {
	    this.active = !this.active;
	    this.$emit('Toggle', this.active);
	}
}
